import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';

import type { Props as TextinputProps } from '@zimpel/common/components/TextInput';
import TextInput from '@zimpel/common/components/TextInput';
import ErrorHint from '@zimpel/common/components/ErrorHint';

export type Props = { name: string } & Omit<TextinputProps, 'name' | '$hasError'>;

const Wrapper = styled.div<{ $width?: string }>`
  width: ${({ $width }) => ($width || '100%')};
`;

const FormikTextInput: React.FC<Props> = ({
  name, $width, ...props
}) => {
  const [field, meta] = useField(name);
  let errorMessage = meta.error ? <ErrorHint>{meta.error}</ErrorHint> : null;
  if (Array.isArray(meta.error)) {
    errorMessage = <>{meta.error.map((m, i) => <ErrorHint key={i}>{m}</ErrorHint>)}</>;
  }
  return (
    <Wrapper $width={$width}>
      <TextInput {...field} {...props} $hasError={!!meta.error} />
      {errorMessage}
    </Wrapper>
  );
};

export default FormikTextInput;
